import { useContext } from "react";

import { CurrentUserContext } from "@/features/users/components/CurrentUserContext";

/**
 * Custom hook to access current user context
 * This hook provides access to Firestore user data, separate from authentication
 *
 * @returns Current user context with user data and methods
 * @throws Error if used outside of CurrentUserProvider
 *
 * @example
 * ```typescript
 * const { currentUserData, loading, error, refreshUserData } = useCurrentUserContext();
 *
 * if (loading) return <div>Loading user data...</div>;
 * if (error) return <div>Error: {error}</div>;
 * if (currentUserData) {
 *   console.log('Current user:', currentUserData.name);
 * }
 * ```
 */
export function useCurrentUserContext() {
  const context = useContext(CurrentUserContext);

  if (context === undefined) {
    throw new Error("useCurrentUserContext must be used within a CurrentUserProvider");
  }

  return context;
}
